import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Stats.css';

export default function Stats() {
  const statItems = [
    { number: '50K+', label: 'Canadian Players Tracked' },
    { number: '200+', label: 'Elite Soccer Academies' },
    { number: '10M+', label: 'Data Points Analyzed' },
    { number: '100%', label: 'FIFA Quality Approved' }
  ];

  const cardRefs = useScrollReveal(statItems.length);

  return (
    <section className="stats-section">
      <div className="stats-container container">
        <div className="stats-grid">
          {statItems.map((item, idx) => (
            <div 
              key={idx} 
              className="stat-card"
              ref={(el) => (cardRefs.current[idx] = el)}
            >
              <h3 className="stat-number">{item.number}</h3>
              <p className="stat-label">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
